/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable camelcase */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d

export const lblHeaderBag = 'lbl_header_bag';
export const lblOrderledgerCoupons = 'lbl_orderledger_coupons';
export const lblOrderledgerPromotions = 'lbl_orderledger_promotions';
export const lblOrderledgerTax = 'lbl_orderledger_tax';
export const lblOrderledgerTotal = 'lbl_orderledger_total';
export const lblOrderledgerGiftcards = 'lbl_orderledger_giftcards';
export const lblOrderledgerBalance = 'lbl_orderledger_balance';
export const lblOrderledgerTooltiptext = 'lbl_orderledger_tooltiptext';
export const lblCouponformPlaceholder = 'lbl_couponform_placeholder';
export const lblCouponformSubmit = 'lbl_couponform_submit';
export const lblCartTileBopis = 'lbl_cartTile_bopis';
export const lblOrderledgerFree = 'lbl_orderledger_free';
export const lblEmptyBagLoggedInMsg = 'lbl_emptyBag_loggedInMsg';
export const lblEmptyBagNotLoggedInMsg = 'lbl_emptyBag_notLoggedInMsg';
export const lblEmptyBagLoginIn = 'lbl_emptyBag_loginIn';
export const lblEmptyBagInspirationTagLine = 'lbl_emptyBag_inspirationTagLine';
export const lblEmptyBagHelperMsg = 'lbl_emptyBag_helperMsg';
export const lblCouponformHeader = 'lbl_couponform_header';
export const lblCouponformHelp = 'lbl_couponform_help';
export const lblCouponlistAvailable = 'lbl_couponlist_available';
export const lblCouponlistApplied = 'lbl_couponlist_applied';
export const lblCouponlistHelpAppling = 'lbl_couponlist_helpAppling';
export const lblCouponlistApplyBtn = 'lbl_couponlist_applyBtn';
export const lblCouponlistShowMoreTxt = 'lbl_couponlist_showMoreTxt';
export const lblCouponlistLessMoreTxt = 'lbl_couponlist_lessMoreTxt';
export const lblCouponlistApplyTobag = 'lbl_couponlist_applyTobag';
export const lblCouponlistPrintTxt = 'lbl_couponlist_printTxt';
export const lblCouponlistUseBy = 'lbl_couponlist_useBy';
export const lblCouponlistModalLongDesc = 'lbl_couponlist_modalLongDesc';
export const lblCouponlistModalShortDesc = 'lbl_couponlist_modalShortDesc';
export const lblCouponlistPPolicy = 'lbl_couponlist_pPolicy';
export const lblCouponlistPlaceCash = 'lbl_couponlist_placeCash';
export const lblCouponlistRewards = 'lbl_couponlist_rewards';
export const lblCouponlistSavings = 'lbl_couponlist_savings';
export const lblCouponlistExpiring = 'lbl_couponlist_expiring';
export const lblSflViewsfl = 'lbl_sfl_viewsfl';
export const lblSflMaxLimitError = 'lbl_sfl_maxLimitError';
export const lblSflActionError = 'lbl_sfl_actionError';
export const blSflActionSuccess = 'bl_sfl_actionSuccess';
export const lblSflMoveToBag = 'lbl_sfl_moveToBag';
export const lblSflSavedForLater = 'lbl_sfl_savedForLater';
export const lblCouponCollapsibleHeader = 'lbl_coupon_collapsible_header';
export const lblSflSavedLaterButton = 'lbl_sfl_savedLaterButton';
export const lblSflEmptySflMsg1 = 'lbl_sfl_emptySflMsg_1';
export const lblSflEmptySflMsg2 = 'lbl_sfl_emptySflMsg_2';
export const lblItemDeleteModalTitle = 'lbl_itemDelete_modalTitle';
export const lblItemDeleteModalHeading = 'lbl_itemDelete_modalHeading';
export const lblItemDeleteModalButtonSFL = 'lbl_itemDelete_modalButtonSFL';
export const lblItemDeleteModalButtonConfirmDelete = 'lbl_itemDelete_modalButtonConfirmDelete';
export const lblMsgItemDeleteSuccess = 'lbl_msg_itemDeleteSuccess';
export const lblSflItemDeleteSuccess = 'lbl_sfl_itemDeleteSuccess';
export const lblOrderledgerTitle = 'lbl_orderledger_title';
export const lblOrderledgerGiftServices = 'lbl_orderledger_giftServices';
export const lblCouponSeeRedeemDates = 'lbl_coupon_seeRedeemDates';
export const lblFreeShippingBannerLabel = 'lbl_freeShippingBanner_label';
export const lblFreeShippingBannerUrlApp = 'lbl_freeShippingBanner_url_app';
export const lblSflItemMoveToBagSuccess = 'lbl_sfl_itemMoveToBagSuccess';
export const lblOrderledgerTotalConfirmation = 'lbl_orderledger_totalConfirmation';
export const lblConfirmationPaidWithVenmo = 'lbl_confirmation_paid_with_venmo';
export const lblVenmoProceedCheckout = 'lbl_venmo_proceed_checkout';
export const lblEddArrivesby = 'lbl_edd_arrivesby';
export const lblCouponExpiredError = 'lbl_coupon_expired_error';
export const lblSflCartSflMergedSuccessMsg = 'lbl_sfl_cartSflMergedSuccessMsg';
export const lblCouponPlaceCashError = 'lbl_coupon_placeCash_error';
export const lblApplepayNonEligibleStateErrorMessage = 'lbl_applepay_nonEligibleStateErrorMessage';
export const lblApplepayNonEligibleCountryErrorMessage =
  'lbl_applepay_nonEligibleCountryErrorMessage';
export const lblApplepayEstimatedTax = 'lbl_applepay_estimatedTax';
export const lblApplepaySubTotal = 'lbl_applepay_subTotal';
export const lblYouRecentlyViewed = 'lbl_you_recently_viewed';
export const lblYouMayAlsoLike = 'lbl_you_may_also_like';
export const lblApplepayRequiredCity = 'lbl_applepay_required_city';
export const lblApplepayRequiredState = 'lbl_applepay_required_state';
export const lblApplepayRequiredPostalCode = 'lbl_applepay_required_postal_code';
export const lblApplepayMultipleLocations = 'lbl_applepay_multipleLocations';
export const lblApplepayPickUpAt = 'lbl_applepay_pickUpAt';
export const lblApplepayGiftServices = 'lbl_applepay_giftServices';
export const lblApplepayNoLastNameErrorMessage = 'lbl_applepay_noLastNameErrorMessage';
export const lblApplepayInvalidStreetName = 'lbl_applepay_invalid_street_name';
export const lblApplepayInvalidCityOrState = 'lbl_applepay_invalid_City_or_State';
export const lblApplepayInvalidHouseNumber = 'lbl_applepay_invalid_house_number';
export const lblApplepayInvalidPoBoxNumber = 'lbl_applepay_invalid_po_box_number';
export const lblApplepayInvalidMailboxNumber = 'lbl_applepay_invalid_mailbox_number';
export const lblApplepayInvalidAddress = 'lbl_applepay_invalid_address';
export const lblApplepayInvalidPostalCode = 'lbl_applepay_invalid_postal_code';
export const lblApplepayNoPhoneNumberErrorMessage = 'lbl_applepay_noPhoneNumberErrorMessage';
export const lblApplepayNoEmailAddressErrorMessage = 'lbl_applepay_noEmailAddressErrorMessage';
export const lblApplepayDiscounts = 'lbl_applepay_discounts';
export const lblCouponMergecartError = 'lbl_coupon_mergecart_error';
export const lblCouponMaxQuantityError = 'lbl_coupon_max_quantity_error';
export const lblSigninCtaBannerSignin = 'lbl_signin_cta_banner_signin';
export const lblYouMayAlsoLikeEmptyBagPage = 'lbl_you_may_also_like_empty_bag_page';
export const lblRecentlyViewedEmptyBagPage = 'lbl_recently_viewed_empty_bag_page';
export const lblYouMayAlsoLikeFullBagPage = 'lbl_you_may_also_like_full_bag_page';
export const lblRecentlyViewedFullBagPage = 'lbl_recently_viewed_full_bag_page';
export const lblConfirmationPage = 'lbl_confirmation_page';
export const lblConfirmationPageOrderNotification = 'lbl_confirmation_page_order_notification';
export const lblCouponOnholdError = 'lbl_coupon_onhold_error';
export const lblCouponlistOnhold = 'lbl_couponlist_onhold';
export const lblEstimateToArrive = 'lbl_estimate_to_arrive';
export const lblPreorderItemsEdd = 'lbl_preorder_items_edd';
export const lblFreeShippingCartTile = 'lbl_freeShipping_cartTile';
export const lblNeedASAPCartTile = 'lbl_NeedASAP_cartTile';
export const lblPtsCartTile = 'lbl_Pts_cartTile';
export const lblQtyCartTile = 'lbl_Qty_cartTile';
export const lblCheckCoupons = 'lbl_check_coupons';
export const lblLowInvetoryCartTile = 'lbl_low_invetory_cart_tile';
export const lblLowInvetoryThresholdShipToHome = 'lbl_low_invetory_threshold_ship_to_home';
export const lblLowInvetoryThresholdBOSS = 'lbl_low_invetory_threshold_BOSS';
export const lblLowInvetoryThresholdBOPIS = 'lbl_low_invetory_threshold_BOPIS';
export const lblFreeShipping = 'lbl_free_shipping';
export const lblLowInvetoryThresholdSFL = 'lbl_low_invetory_threshold_SFL';
export const lblRewardAndCouponTitle = 'lbl_reward_and_coupon_title';
export const lblEstimatedOrderTotal = 'lbl_estimated_order_total';
export const lblUseByDate = 'lbl_use_by_date';
export const lblCouponAppleOnholdError = 'lbl_coupon_apple_onhold_error';
export const lblPreorderDate = 'lbl_preorder_date';
export const lblCouponRemovedError = 'lbl_coupon_removed_error';
export const lblEstimatedTaxAdd = 'lbl_estimated_tax_add';
export const lblBagItemDeleteSuccess = 'lbl_bag_itemDeleteSuccess';
export const lblQtyText = 'lbl_qty_text';
export const lblPreOrderTag = 'lbl_pre_order_tag';
export const lblEstimatedToShip = 'lbl_estimated_to_ship';
export const lblVmpError = 'lbl_vmp_error';
export const lblEstimatedZipPlaceholderCa = 'lbl_estimated_zip_placeholder_ca';
export const lblEstimatedTaxAddCa = 'lbl_estimated_tax_add_ca';
export const lblPlccIcMyPlaceRewards$ = 'lbl_plcc_ic_my_place_rewards$';
export const lblPlccIcCreditCard = 'lbl_plcc_ic_credit_card';
export const lblPlccIcInstantCheckout = 'lbl_plcc_ic_instant_checkout';
export const lblPlccIcBuyNow = 'lbl_plcc_ic_buy_now';
export const lblPlccIcShippingAdress = 'lbl_plcc_ic_shipping_adress';
export const lblPlccIcStoreAddressBossBopis = 'lbl_plcc_ic_store_address_boss_bopis';
export const lblPlccIcTermsCondition = 'lbl_plcc_ic_termsCondition';
export const lblPlccIcToolTipMessage1 = 'lbl_plcc_ic_toolTip_message_1';
export const lblPlccIcTermsConditionPreTextApp = 'lbl_plcc_ic_termsCondition_preText_app';
export const lblPlccIcToolTipMessage2 = 'lbl_plcc_ic_toolTip_message_2';
export const lblExtendedPreOrderMsg = 'lbl_extended_preOrder_msg';
export const lblExtendedPreOrderToolTipMsg = 'lbl_extended_preOrder_toolTip_msg';
export const lblExtendedPreOrderFooterMsg = 'lbl_extended_preOrder_footer_msg';
export const lblOrderledgerBuyWith = 'lbl_orderledger_buyWith';
export const lblHolidayMessage = 'lbl_holiday_message';
export const lblHolidayMessageConfirmation = 'lbl_holiday_message_confirmation';
export const lblCouponInvalidFormatError = 'lbl_coupon_invalid_format_error';
export const test = 'test';
export const lblCouponUnapplied = 'lbl_coupon_unapplied';
export const lblCouponAfterpayMsg = 'lbl_coupon_afterpay_msg';
export const lblCouponAfterpayPickupFrom = 'lbl_coupon_afterpay_pickup_from';
export const lblLoginSuggestionForSfl = 'lbl_login_suggestion_for_sfl';
export const lblSavingForLaterSuggestion = 'lbl_saving_for_later_suggestion';
export const lblCouponformNewHeaderText = 'lbl_couponform_new_header_text';
export const lblSocialProofingMsg = 'lbl_social_proofing_msg';
export const lblCouponGenericOnholdMsg = 'lbl_coupon_generic_onhold_msg';
export const lblCouponThresholdOnholdMsg = 'lbl_coupon_threshold_onhold_msg';
export const lblCouponOfferText = 'lbl_coupon_offerText';
export const lblCouponRewardText = 'lbl_coupon_rewardText';
export const lblCouponValidThru = 'lbl_coupon_validThru';
export const lblCouponPlaceCashRedemption = 'lbl_coupon_placeCash_Redemption';

export const lblBossUnavailableItemLevelError = 'lbl_boss_unavailable_item_level_error';
export const lblBossUnavailableItemLevelError2 = 'lbl_boss_unavailable_item_level_error2';
export const lblBossUnavailableGlobalErrorSubtext = 'lbl_boss_unavailable_global_error_subtext';
export const lblBossUnavailableConfirmationHeading = 'lbl_boss_unavailable_confirmation_heading';
export const lblBossUnavailableConfirmationSubText = 'lbl_boss_unavailable_confirmation_sub_text';
export const lblHangOn = 'lbl_hang_on';
export const lblAddingTheItems = 'lbl_adding_the_items';
export const lblAddItemsToBag = 'lbl_add_items_to_bag';
export const lblUpdateItems = 'lbl_update_items';
export const lblAddToBag = 'lbl_add_to_bag';
export const lblShareCartCancel = 'lbl_share_cart_cancel';

export const lblBossUnavailableConfirmationHeadingOnlyOssItems =
  'lbl_boss_unavailable_confirmation_heading_only_oss_items';
export const lblBagpageShareCart = 'lbl_bagpage_share_cart';
export const lblShareCartSmsCopy = 'lbl_share_cart_sms_copy';
export const lblHolidayDate = 'lbl_holiday_date';

export const lblBillingTitle = 'lbl_billing_title';
export const lblGiftcardAddUptoMsg = 'lbl_giftcard_addUptoMsg';
export const lblGiftcardAppliedCards = 'lbl_giftcard_appliedCards';
export const lblGiftcardEndingIn = 'lbl_giftcard_endingIn';
export const lblGiftcardRemainingBal = 'lbl_giftcard_remainingBal';
export const lblGiftcardHeadsUpTitle = 'lbl_giftcard_headsUpTitle';
export const lblGiftcardHeadsUpMsg = 'lbl_giftcard_headsUpMsg';
export const lblGiftcardAvailableCards = 'lbl_giftcard_availableCards';
export const lblGiftcardApplyBtn = 'lbl_giftcard_applyBtn';
export const lblGiftcardNewGiftCard = 'lbl_giftcard_newGiftCard';
export const lblGiftcardCommonError = 'lbl_giftcard_commonError';
export const lblBillingBackLinkPickup = 'lbl_billing_backLinkPickup';
export const lblBillingBackLinkShipping = 'lbl_billing_backLinkShipping';
export const lblBillingNextSubmit = 'lbl_billing_nextSubmit';
export const lblBillingPaymentMethodTitle = 'lbl_billing_paymentMethodTitle';
export const lblBillingSelectFromCard = 'lbl_billing_selectFromCard';
export const lblBillingAddCreditHeading = 'lbl_billing_addCreditHeading';
export const lblBillingDefault = 'lbl_billing_default';
export const lblBillingCardDetailsTitle = 'lbl_billing_cardDetailsTitle';
export const lblBillingCreditCardEnd = 'lbl_billing_creditCardEnd';
export const lblBillingBillingAddress = 'lbl_billing_billingAddress';
export const lblBillingDefaultPayment = 'lbl_billing_defaultPayment';
export const lblBillingAddCreditBtn = 'lbl_billing_addCreditBtn';
export const lblBillingPaypal = 'lbl_billing_paypal';
export const lblBillingVenmo = 'lbl_billing_venmo';
export const lblBillingDefaultCard = 'lbl_billing_default_card';
export const lblBillingSelectCardTitle = 'lbl_billing_selectCardTitle';
export const lblBillingSelect = 'lbl_billing_select';
export const lblPaymentGiftCardNoPlaceholder = 'lbl_payment_giftCardNoPlaceholder';
export const lblPaymentAddCard = 'lbl_payment_addCard';
export const lblPaymentGiftCardPinPlaceholder = 'lbl_payment_giftCardPinPlaceholder';
export const lblPaymentSaveToAccount = 'lbl_payment_saveToAccount';
export const defaultError = 'default_error';
export const lblBillingSameAsShipping = 'lbl_billing_sameAsShipping';
export const lblBillingSaveToAccount = 'lbl_billing_saveToAccount';
export const lblBillingCvvCode = 'lbl_billing_cvvCode';
export const lblBillingAddNewAddress = 'lbl_billing_addNewAddress';
export const lblBillingContinueWith = 'lbl_billing_continueWith';
export const lblBillingCardEditSave = 'lbl_billing_cardEditSave';
export const lblBillingCardEditUnSavedError = 'lbl_billing_cardEditUnSavedError';
export const lblBillingDefaultError = 'lbl_billing_defaultError';
export const lblBillingAddCC = 'lbl_billing_addCC';
export const paymentSaveToAccount = 'payment_saveToAccount';
export const lblBillingContinueWithPayPal = 'lbl_billing_continueWithPayPal';
export const lblBillingPayPalLongText = 'lbl_billing_payPalLongText';
export const lblBillingVenmoLongText = 'lbl_billing_venmoLongText';
export const lblBillingDiffrentcountry_1 = 'lbl_billing_diffrentcountry_1';
export const lblBillingDiffrentcountry_2 = 'lbl_billing_diffrentcountry_2';
export const lblBillingDiffrentcountry_3 = 'lbl_billing_diffrentcountry_3';
export const lblBillingApplepay = 'lbl_billing_applepay';
export const lblBillingAfterpaySubmit = 'lbl_billing_afterpaySubmit';
export const lblBillingOtherPaymentOptions = 'lbl_billing_otherPaymentOptions';
export const lblApplyNow = 'lbl_apply_now';
export const lblSaveAtCheckoutToday = 'lbl_save_at_checkout_today';
export const lblMy = 'lbl_my';
export const lblPlace = 'lbl_place';
export const lblRewards = 'lbl_rewards';
export const lblExpire = 'lbl_expire';
export const lblMyWallet = 'lbl_my_wallet';
export const lblAddCard = 'lbl_add_card';
export const lblUpdateCardInfo = 'lbl_update_card_info';
export const lblAfterPayDefaultMsg = 'lbl_afterPay_default_msg';
export const lblExpired = 'lbl_expired';
export const lblAddNewCard = 'lbl_add_new_card';
export const lblAddNewCardInfo = 'lbl_add_new_card_info';
export const lblEditCardInfo = 'lbl_edit_card_info';
export const lblEndingWith = 'lbl_ending_with';
export const lblApplyAGiftCard = 'lbl_apply_a_gift_card';
export const lblGiftCardApplied = 'lbl_gift_card_applied';
export const lblGiftCardAvailable = 'lbl_gift_card_available';
export const lblBalance = 'lbl_balance';
export const lblBillingSameAsShippingMessage = 'lbl_billing_sameAsShippingMessage';
export const lblAfterPayGcInCartMsg = 'lbl_afterPay_gc_in_cart_msg';
export const lblBillingAfterpay = 'lbl_billing_afterpay';
export const lblOrderTotalMinThresholdMsg = 'lbl_orderTotal_min_threshold_msg';
export const lblBillingPaymentTitle = 'lbl_billing_payment_title';
export const lblCvvReverifyMsg = 'lbl_cvv_reverify_msg';
export const lblAddCardInfo = 'lbl_add_card_info';
export const lblAddCreditCard = 'lbl_add_credit_card';
export const lblGiftCardAppliedHeading = 'lbl_gift_card_applied_heading';
export const lblAdd = 'lbl_add';
export const lblAddShippingAddress = 'lbl_add_shipping_address';
export const lblShippingAddress = 'lbl_shipping_address';
export const lblBillingSaveToAccountSpc = 'lbl_billing_saveToAccount_spc';
export const lblOrSeparator = 'lbl_or_separator';
export const lblEditCreditCard = 'lbl_edit_credit_card';
export const noLabel = 'No Label';
export const lblEditShippingAddress = 'lbl_edit_shipping_address';
export const lblPaymentSaveToAccountSpc = 'lbl_payment_saveToAccount_spc';
export const lblApplyGiftCardCta = 'lbl_apply_gift_card_cta';
export const lblGiftCardsAppliedHeading = 'lbl_gift_cards_appliedHeading';
export const lblGiftCardsAvailableHeading = 'lbl_gift_cards_availableHeading';
export const lblPaymentGiftCardAvailableHeading = 'lbl_payment_giftCardAvailableHeading';
export const lblApplePayDisplayMessageHeading = 'lbl_applePay_displayMessageHeading';
export const lblApplePayDisplayMessage = 'lbl_applePay_displayMessage';
export const lblPaymentReturnForReview = 'lbl_payment_return_for_review';
export const lblApplePayDirectOrder = 'lbl_applePay_direct_order';

export const lblCheckoutheaderCheckout = 'lbl_checkoutheader_checkout';
export const lblCheckoutheaderReturnBag = 'lbl_checkoutheader_returnBag';
export const lblCheckoutHeaderBilling = 'lbl_checkoutHeader_billing';
export const lblCheckoutHeaderReview = 'lbl_checkoutHeader_review';
export const lblCheckoutHeaderExpressCheckout = 'lbl_checkoutHeader_expressCheckout';
export const lblContactHeader = 'lbl_contact_header';

export const lblConfirmationHeading = 'lbl_confirmation_heading';
export const lblConfirmationMixOrderMsg1 = 'lbl_confirmation_mixOrderMsg1';
export const lblConfirmationMixOrderMsg2 = 'lbl_confirmation_mixOrderMsg2';
export const lblConfirmationOrderMsg1 = 'lbl_confirmation_orderMsg1';
export const lblConfirmationShippingMsg = 'lbl_confirmation_shippingMsg';
export const lblConfirmationPickup = 'lbl_confirmation_pickup';
export const lblConfirmationOrderMsg2 = 'lbl_confirmation_orderMsg2';
export const lblConfirmationPendingOrderMsg = 'lbl_confirmation_pendingOrderMsg';
export const lblConfirmationPickupAt = 'lbl_confirmation_pickupAt';
export const lblConfirmationShippingTo = 'lbl_confirmation_shippingTo';
export const lblConfirmationItem = 'lbl_confirmation_item';
export const lblConfirmationBopisDate = 'lbl_confirmation_bopisDate';
export const lblConfirmationToday = 'lbl_confirmation_today';
export const lblConfirmationTomorrow = 'lbl_confirmation_tomorrow';
export const lblConfirmationPhone = 'lbl_confirmation_phone';
export const lblConfirmationOrderNumber = 'lbl_confirmation_orderNumber';
export const lblConfirmationOrderDate = 'lbl_confirmation_orderDate';
export const lblConfirmationOrderTotal = 'lbl_confirmation_orderTotal';
export const lblCreateAccountHeading = 'lbl_createAccount_heading';
export const lblConfirmationNextHeading = 'lbl_confirmation_nextHeading';
export const lblConfirmationNextDetailsBoss = 'lbl_confirmation_nextDetails_boss';
export const lblConfirmationUpdateOrderHeading = 'lbl_confirmation_updateOrderHeading';
export const lblConfirmationNextDetails = 'lbl_confirmation_nextDetails';
export const lblOdmCouponsHeading_1 = 'lbl_odmCoupons_heading_1';
export const lblOdmCouponsHeading_2 = 'lbl_odmCoupons_heading_2';
export const lblOdmCouponsWebCode = 'lbl_odmCoupons_webCode';
export const lblOdmCouponsValidTill = 'lbl_odmCoupons_validTill';
export const lblOdmCouponsNowThrough = 'lbl_odmCoupons_nowThrough';
export const lblConfirmationVenmoHeading = 'lbl_confirmation_venmo_heading';
export const lblConfirmationVenmoShipInformation = 'lbl_confirmation_venmo_ship_information';
export const lblSmsNotificationHeading_1 = 'lbl_smsNotification_heading_1';
export const lblSmsNotificationHeading_2 = 'lbl_smsNotification_heading_2';
export const lblSmsNotificationJoinNowBtn = 'lbl_smsNotification_joinNow_btn';
export const lblSmsNotificationPhoneLbl = 'lbl_smsNotification_phone_lbl';
export const lblSmsNotificationSubscribeSuccess = 'lbl_smsNotification_subscribeSuccess';
export const lblConfirmationRatingTitle = 'lbl_confirmation_ratingTitle';
export const lblConfirmationRatingBody = 'lbl_confirmation_ratingBody';
export const lblConfirmationRatingSureCTA = 'lbl_confirmation_ratingSureCTA';
export const lblConfirmationRatingMayBeCTA = 'lbl_confirmation_ratingMayBeCTA';
export const lblHelpWithOrderReceipts = 'lbl_help_with_order_receipts';
export const lblHelpWithOrderModalOpen = 'lbl_help_with_order_modal_open';
export const lblMoreHelpResendConfirmText = 'lbl_more_help_resend-confirm-text';
export const lblMoreHelpReturnPolicyText = 'lbl_more_help_return_policy_text';
export const lblMoreHelpChangePickUpText = 'lbl_more_help_change_pick_up_text';
export const lblMoreHelpExtendPickUpText = 'lbl_more_help_extend_pick_up_text';
export const lblOrderStatusHelpText = 'lbl_order_status_help_text';
export const lblHelpCenterText = 'lbl_help_center_text';
export const lblOrderStatusText = 'lbl_order_status_text';
export const lblLeaveFeedbackText = 'lbl_leave_feedback_text';
export const lblNeedHelpText = 'lbl_need_help_text';
export const lblConfirmationGuestInstructionMsg = 'lbl_confirmation_guest_instruction_msg';
export const lblConfirmationGuestConversionMsg = 'lbl_confirmation_guest_conversion_msg';
export const lblConfirmationGuestConversionYey = 'lbl_confirmation_guest_conversion_yey';
export const lblConfirmationOrderDetailsHeading = 'lbl_confirmation_orderDetails_heading';
export const lblConfirmationOrderDetailsItemCount = 'lbl_confirmation_orderDetails_itemCount';
export const lblConfirmationOrderDetailsHelpCenterText =
  'lbl_confirmation_orderDetails_helpCenter_text';
export const lblConfirmationOrderNumberMsg = 'lbl_confirmation_orderNumberMsg';
export const lblConfirmationOrderNumberMsgNew = 'lbl_confirmation_orderNumberMsgNew';
export const lblMoreHelpResendConfirmImg = 'lbl_more_help_resend-confirm-img';
export const lblMoreHelpReturnPolicyUrl = 'lbl_more_help_return_policy_url';
export const lblMoreHelpReturnPolicyImg = 'lbl_more_help_return_policy_img';
export const lblOrderStatusHelpImg = 'lbl_order_status_help_img';
export const lblOrderStatusHelpUrl = 'lbl_order_status_help_url';
export const lblHelpCenterUrl = 'lbl_help_center_url';
export const lblOrderStatusUrl = 'lbl_order_status_url';
export const lblNeedHelpImg = 'lbl_need_help_img';
export const lblLeaveFeedbackUrl = 'lbl_leave_feedback_url';
export const lblCreateAccountHeading1 = 'lbl_createAccount_heading1';
export const lblCreateAccountSubHeading1 = 'lbl_createAccount_sub_heading1';
export const lblCreateAccountSucccessMsg = 'lbl_createAccount_succcessMsg';
export const lblCreateAccountSucccessMsgPara = 'lbl_createAccount_succcessMsgPara';
export const lblCreateAccountSucccessYay = 'lbl_createAccount_succcess_yay';
export const lblReferAFriendHeadingForFriend = 'lbl_refer_a_friend_heading_for_friend';
export const lblReferAFriendHeadingForYou = 'lbl_refer_a_friend_heading_for_you';
export const lblReferAFriendBtnText = 'lbl_refer_a_friend_btn_text';
export const lblInitiateReturnImg = 'lbl_initiate_return_img';
export const lblConfirmationEmailSignUpHeader = 'lbl_confirmation_emailSignUpHeader';
export const lblConfirmationCarrierMessage = 'lbl_confirmation_carrierMessage';

export const lblPickupTitle = 'lbl_pickup_title';
export const lblPickupTitleContact = 'lbl_pickup_titleContact';
export const lblPickupGovIdText = 'lbl_pickup_govIdText';
export const lblPickupMobile = 'lbl_pickup_mobile';
export const lblPickupAlternativeHeading = 'lbl_pickup_alternativeHeading';
export const lblPickupAlternativeSubHeading = 'lbl_pickup_alternativeSubHeading';
export const lblPickupAlternativeGovIdText = 'lbl_pickup_alternativeGovIdText';
export const lblPickupEmailSignupContact = 'lbl_pickup_emailSignupContact';
export const lblPickupPickupContact = 'lbl_pickup_pickup_contact';
export const lblPickupReturnTo = 'lbl_pickup_returnTo';
export const lblPickupNextText = 'lbl_pickup_nextText';
export const lblPickupBillingText = 'lbl_pickup_billingText';
export const lblPickupBtnSaveUpdate = 'lbl_pickup_btnSaveUpdate';
export const lblPickupTitleEditPickUp = 'lbl_pickup_titleEditPickUp';
export const lblPickupVenmoBanner = 'lbl_pickup_venmo_banner';
export const lblPickupReviewText = 'lbl_pickup_reviewText';
export const lblPickupNextToBilling = 'lbl_pickup_nextToBilling';
export const lblPickupEditFormSubmitError = 'lbl_pickup_editFormSubmitError';
export const lblPickupInfoTitle = 'lbl_pickup_info_title';
export const lblPickupContactTitle = 'lbl_pickup_contact_title';
export const lblAlternatePickupContactTitle = 'lbl_alternate_pickup_contact_title';
export const lblEditPickupInfoTitle = 'lbl_edit_pickup_info_title';
export const lblPickupDescOne = 'lbl_pickup_desc_one';
export const lblAlternatePersonSwitch = 'lbl_alternate_person_switch';
export const lblPickupDescTwo = 'lbl_pickup_desc_two';
export const lblCheckouterrorMsg = 'lbl_checkouterror_msg';
export const lblCheckouterrorContactMsg = 'lbl_checkouterror_contact_msg';
export const lblCheckouterrorShipmentMsg = 'lbl_checkouterror_shipment_msg';
export const lblCheckouterrorPaymentMsg = 'lbl_checkouterror_payment_msg';

export const lblPlaceCash_USBagTitle = 'lbl_placeCash_US_bag_title';
export const lblPlaceCash_CABagTitle = 'lbl_placeCash_CA_bag_title';
export const lblPlaceCash_USConfirmationTitle = 'lbl_placeCash_US_confirmation_title';
export const lblPlaceCash_CAConfirmationTitle = 'lbl_placeCash_CA_confirmation_title';
export const lblPlaceCash_USBagSubTitle = 'lbl_placeCash_US_bag_subTitle';
export const lblPlaceCash_CABagSubTitle = 'lbl_placeCash_CA_bag_subTitle';
export const lblPlaceCash_USBagTnc = 'lbl_placeCash_US_bag_tnc';
export const lblPlaceCash_CABagTnc = 'lbl_placeCash_CA_bag_tnc';
export const lblPlaceCash_USConfirmationTnc = 'lbl_placeCash_US_confirmation_tnc';
export const lblPlaceCash_CAConfirmationTnc = 'lbl_placeCash_CA_confirmation_tnc';
export const lblPlaceCash_USBagModalLink = 'lbl_placeCash_US_bag_modalLink';
export const lblPlaceCash_CABagModalLink = 'lbl_placeCash_CA_bag_modalLink';
export const lblPlaceCash_USConfirmationModalLink = 'lbl_placeCash_US_confirmation_modalLink';
export const lblPlaceCash_CAConfirmationModalLink = 'lbl_placeCash_CA_confirmation_modalLink';
export const lblPlaceCash_USBagDetailModalTitle = 'lbl_placeCash_US_bag_detailModalTitle';
export const lblPlaceCash_CABagDetailModalTitle = 'lbl_placeCash_CA_bag_detailModalTitle';
export const lblPlaceCash_USConfirmationDetailModalTitle =
  'lbl_placeCash_US_confirmation_detailModalTitle';
export const lblPlaceCash_CAConfirmationDetailModalTitle =
  'lbl_placeCash_CA_confirmation_detailModalTitle';
export const lblPlaceCashProgress_USBeforeCartAmount =
  'lbl_placeCash_progress_US_before_cartAmount';
export const lblPlaceCashProgress_USAfterAmount = 'lbl_placeCash_progress_US_after_amount';
export const lblPlaceCashProgress_USPlaceBucks = 'lbl_placeCash_progress_US_place_bucks';
export const lblPlaceCashProgress_CAPlaceBucks = 'lbl_placeCash_progress_CA_place_bucks';
export const lblPlaceCashProgress_CAAfterAmount = 'lbl_placeCash_progress_CA_after_amount';
export const lblPlaceCashProgress_CABeforeCartAmount =
  'lbl_placeCash_progress_CA_before_cartAmount';
export const lblPlaceCashProgress_USBetweenAmount = 'lbl_placeCash_progress_US_between_amount';
export const lblPlaceCashProgress_CABetweenAmount = 'lbl_placeCash_progress_CA_between_amount';
export const lblPlaceCashProgress_USAfterBucks = 'lbl_placeCash_progress_US_after_bucks';
export const lblPlaceCashProgress_CAAfterBucks = 'lbl_placeCash_progress_CA_after_bucks';
export const lblPlaceCash_USBagStartDate = 'lbl_placeCash_US_bag_startDate';
export const lblPlaceCash_USBagEndDate = 'lbl_placeCash_US_bag_endDate';
export const lblPlaceCashToUse = 'lbl_placeCash_to_use';
export const lblPlacerewardModelHeader = 'lbl_placereward_model_header';
export const lblPlacerewardModelDescription = 'lbl_placereward_model_description';
export const lblPlacerewardUsProgressBeforePoints = 'lbl_placereward_us_progress_before_points';
export const lblPlacerewardUsProgressTitle2 = 'lbl_placereward_us_progress_title2';
export const lblPlacerewardUsProgressAfterPoints = 'lbl_placereward_us_progress_after_points';
export const lblPlacerewardUsProgressRewardValue = 'lbl_placereward_us_progress_reward_value';
export const lblPlaceCash_USBagAltName = 'lbl_placeCash_US_bag_altName';
export const lblPlaceCash_CABagAltName = 'lbl_placeCash_CA_bag_altName';

export const lblReviewTitle = 'lbl_review_title';
export const lblReviewBackLinkBilling = 'lbl_review_backLinkBilling';
export const lblReviewNextSubmit = 'lbl_review_nextSubmit';
export const lblReviewApplyConditionPreText = 'lbl_review_applyConditionPreText';
export const lblReviewApplyConditionAndText = 'lbl_review_applyConditionAndText';
export const lblReviewApplyConditionPolicyText = 'lbl_review_applyConditionPolicyText';
export const lblReviewBillingSectionTitle = 'lbl_review_billingSectionTitle';
export const lblReviewPickupSectionTitle = 'lbl_review_pickupSectionTitle';
export const lblReviewPaymentMethod = 'lbl_review_paymentMethod';
export const lblReviewAppliedGiftCards = 'lbl_review_appliedGiftCards';
export const lblReviewBillingAddress = 'lbl_review_billingAddress';
export const lblReviewPaymentMethodEndingIn = 'lbl_review_paymentMethodEndingIn';
export const lblReviewAppliedGiftCardEndingIn = 'lbl_review_appliedGiftCardEndingIn';
export const lblReviewAppliedGiftCardRemainingBal = 'lbl_review_appliedGiftCardRemainingBal';
export const lblReviewGiftCardHeadsup = 'lbl_review_giftCardHeadsup';
export const lblReviewGiftCardMessage = 'lbl_review_giftCardMessage';
export const lblReviewAppliedGiftCardsNone = 'lbl_review_appliedGiftCardsNone';
export const lblReviewSectionPickupText = 'lbl_review_sectionPickupText';
export const lblReviewSectionPickupItem = 'lbl_review_sectionPickupItem';
export const lblReviewSectionPickupItems = 'lbl_review_sectionPickupItems';
export const lblReviewSectionPickupToday = 'lbl_review_sectionPickupToday';
export const lblReviewSectionPickupAlternateHeading = 'lbl_review_sectionPickupAlternateHeading';
export const lblReviewSectionShippingAddressTitle = 'lbl_review_sectionShippingAddressTitle';
export const lblReviewSectionShippingMethodTitle = 'lbl_review_sectionShippingMethodTitle';
export const lblReviewSectionShippingGiftServiceTitle =
  'lbl_review_sectionShippingGiftServiceTitle';
export const lblReviewSectionShippingGiftServiceDefault =
  'lbl_review_sectionShippingGiftServiceDefault';
export const lblReviewSectionPickupOrderTitle = 'lbl_review_sectionPickupOrderTitle';
export const lblReviewSaveVenmo = 'lbl_review_save_venmo';
export const lblReviewShippingShipmentHeader = 'lbl_review_shipping_shipmentHeader';
export const lblReviewCvvCode = 'lbl_review_cvvCode';
export const lblReviewEmptyBagSubText = 'lbl_review_emptyBagSubText';
export const lblReviewEmptyBagText = 'lbl_review_emptyBagText';
export const lblReviewAfterpaySubmit = 'lbl_review_afterpaySubmit';
export const lblReviewCashAppAfterpaySubmit = 'lbl_review_cashapp_afterpaySubmit';
export const lblReviewAfterpayMessage = 'lbl_review_afterpayMessage';
export const lblReviewAfterpayThresholdError = 'lbl_review_afterpayThresholdError';
export const lblReviewApplyConditionTermsText = 'lbl_review_applyConditionTermsText';

export const lblShippingHeader = 'lbl_shipping_header';
export const lblShippingSectionHeader = 'lbl_shipping_sectionHeader';
export const lblShippingShipmentHeader = 'lbl_shipping_shipmentHeader';
export const lblShippingBackLinkText = 'lbl_shipping_backLinkText';
export const lblShippingBillingText = 'lbl_shipping_billingText';
export const lblShippingAddNewAddress = 'lbl_shipping_addNewAddress';
export const lblShippingEdit = 'lbl_shipping_edit';
export const lblShippingSaveToAccount = 'lbl_shipping_saveToAccount';
export const lblShippingDefaultShipping = 'lbl_shipping_defaultShipping';
export const lblShippingSave = 'lbl_shipping_save';
export const lblShippingSelectShipAdd = 'lbl_shipping_selectShipAdd';
export const lblShippingAddHeading = 'lbl_shipping_addHeading';
export const lblShippingEditHeading = 'lbl_shipping_editHeading';
export const lblGiftServicesHeader = 'lbl_giftServices_header';
export const lblGiftServicesAdd1 = 'lbl_giftServices_add1';
export const lblGiftServicesAdd = 'lbl_giftServices_add';
export const lblGiftServicesSelect = 'lbl_giftServices_select';
export const lblShippingGiftServicesTcpOptionName1 = 'lbl_shipping_giftServicesTcpOptionName1';
export const lblShippingGiftServicesGymOptionName1 = 'lbl_shipping_giftServicesGymOptionName1';
export const lblShippingGiftServicesTcpOptionPrice1 = 'lbl_shipping_giftServicesTcpOptionPrice1';
export const lblShippingGiftServicesTcpOptionDesc1 = 'lbl_shipping_giftServicesTcpOptionDesc1';
export const lblShippingGiftServicesGymOptionDesc1 = 'lbl_shipping_giftServicesGymOptionDesc1';
export const lblShippingGiftServicesTcpOptionName2 = 'lbl_shipping_giftServicesTcpOptionName2';
export const lblShippingGiftServicesGymOptionName2 = 'lbl_shipping_giftServicesGymOptionName2';
export const lblShippingGiftServicesTcpOptionDesc2 = 'lbl_shipping_giftServicesTcpOptionDesc2';
export const lblShippingGiftServicesGymOtionDesc2 = 'lbl_shipping_giftServicesGymOtionDesc2';
export const lblShippingGiftServicesTcpOptionName3 = 'lbl_shipping_giftServicesTcpOptionName3';
export const lblShippingGiftServicesGymOptionName3 = 'lbl_shipping_giftServicesGymOptionName3';
export const lblShippingGiftServicesTcpOptionDesc3 = 'lbl_shipping_giftServicesTcpOptionDesc3';
export const lblShippingGiftServicesGymOptionDesc3 = 'lbl_shipping_giftServicesGymOptionDesc3';
export const lblShippingDefault = 'lbl_shipping_default';
export const lblGiftServicesCharLimit = 'lbl_giftServices_charLimit';
export const lblGiftServicesAddMessage = 'lbl_giftServices_addMessage';
export const lblShippingReviewText = 'lbl_shipping_reviewText';
export const lblShippingAddressEditError = 'lbl_shipping_addressEditError';
export const lblShippingEmailSignUpHeader = 'lbl_shipping_emailSignUpHeader';
export const lblShippingEmailSignUpSubHeader = 'lbl_shipping_emailSignUpSubHeader';
export const lblShippingGymboreePlaceCheckoutTxt = 'lbl_shipping_gymboreePlaceCheckoutTxt';
export const lblShippingEmailSignUpDisclaimer = 'lbl_shipping_emailSignUpDisclaimer';
export const lblGiftServicesHelp = 'lbl_giftServices_help';
export const lblSfsShippingAddressError = 'lbl_sfs_shipping_address_error';
export const lblSfsCartItemError = 'lbl_sfs_cart_item_error';
export const lblSfsOrderError = 'lbl_sfs_order_error';
export const lblSfsErrorRushShipping = 'lbl_sfs_error_rush_shipping';
export const lblSfsErrorGiftService = 'lbl_sfs_error_gift_service';
export const lblSfsErrorShippingAddress = 'lbl_sfs_error_shipping_address';
export const lblSfsErrorAddressRush = 'lbl_sfs_error_address_rush';
export const lblSfsErrorGiftAddress = 'lbl_sfs_error_gift_address';
export const lblSfsErrorGiftRush = 'lbl_sfs_error_gift_rush';
export const lblSfsSflCta = 'lbl_sfs_sfl_cta';
export const lblSfsAddressCta = 'lbl_sfs_address_cta';
export const lblSfsShippingCta = 'lbl_sfs_shipping_cta';
export const lblSfsGiftserviceCta = 'lbl_sfs_giftservice_cta';
export const lblAddGiftServices = 'lbl_add_gift_services';
export const lblCheckboxYes = 'lbl_checkbox_yes';
export const lblCheckboxNo = 'lbl_checkbox_no';
export const lblGiftServiceOptionNone = 'lbl_gift_service_option_none';
export const lblGiftServiceSave = 'lbl_gift_service_save';
export const lblGiftServiceOptional = 'lbl_gift_service_optional';
export const lblGiftServiceSelectABrand = 'lbl_gift_service_select_a_brand';
export const lblNoGiftServiceSelected = 'lbl_no_gift_service_selected';
export const lblShippingAddressHeader = 'lbl_shipping_address_header';
export const lblShippingEmailSignUpHeaderCaNew = 'lbl_shipping_emailSignUpHeader_ca_new';
export const lblGiftServiceNoteStandard = 'lbl_gift_service_note_standard';
export const lblGiftServiceNoteDelux = 'lbl_gift_service_note_delux';

export default {
  checkout: {
    AddedToBag: {
      referred: [],
      lbl_cta_viewBag: 'View Bag',
      lbl_cta_checkout: 'Checkout',
      lbl_header_addedToBag: 'ADDED TO BAG',
      lbl_info_color: 'Color',
      lbl_info_size: 'Size',
      lbl_info_Qty: 'Qty',
      lbl_info_price: 'Price',
      lbl_info_pointYouCanEarn: 'Points you can earn on Item(s)',
      lbl_info_subTotal: 'Bag Subtotal (#items items)',
      lbl_info_totalRewardsInBag: 'Total My Place Reward Points in Bag',
      lbl_info_totalNextRewards: 'Total Points to Next Reward',
      lbl_bossBanner_subHeadingDefault: 'Simply choose “#type” in your bag before checking out.',
      lbl_bossBanner_noRush: 'NO RUSH Pick Up',
      lbl_info_giftDesign: 'Design',
      lbl_aria_close: 'close',
      lbl_aria_overlayText: 'Tap to close added to bag overlay',
      lbl_heading_styleWith: 'STYLE WITH',
    },
    bagBonusPoints: {
      referred: [],
      lbl_bonusPoints_usedOn: 'USED ON',
      lbl_bonusPoints_futureUse: 'AVAILABLE FOR FUTURE USE',
      lbl_bonusPoints_ctaApply: 'AVAILABLE TODAY!',
      lbl_bonusPoints_ctaApplied: 'APPLIED TO ORDER',
    },
    bagPage: {
      referred: [
        {
          name: null,
          contentId: '18d258d7-9863-49a5-9cae-fc127c8d25a7',
          __typename: 'ReferredContent',
        },
      ],
      [lblHeaderBag]: 'MY BAG',
      [lblOrderledgerCoupons]: 'Coupons',
      [lblOrderledgerPromotions]: 'Promotions',
      [lblOrderledgerTax]: 'Estimated Tax',
      [lblOrderledgerTotal]: 'Estimated Total',
      [lblOrderledgerGiftcards]: 'Gift Card(s)',
      [lblOrderledgerBalance]: 'Balance',
      [lblOrderledgerTooltiptext]:
        'Total includes any applied promotions or coupons in addition to on sale savings',
      [lblCouponformPlaceholder]: 'Enter Code',
      [lblCouponformSubmit]: 'Apply',
      [lblCartTileBopis]: 'I’ll pick up in store at #store# Today',
      [lblOrderledgerFree]: 'FREE',
      [lblEmptyBagLoggedInMsg]: 'Uh oh! Looks like you don’t have anything in your bag yet!',
      [lblEmptyBagNotLoggedInMsg]: 'Do you have items in your Bag?',
      [lblEmptyBagLoginIn]: 'LOG IN',
      [lblEmptyBagInspirationTagLine]: '',
      [lblEmptyBagHelperMsg]: '',
      [lblCouponformHeader]: 'COUPON CODE',
      [lblCouponformHelp]: 'Need help?',
      [lblCouponlistAvailable]: 'Available',
      [lblCouponlistApplied]: 'Applied',
      [lblCouponlistHelpAppling]: 'Help applying Place Bucks',
      [lblCouponlistApplyBtn]: 'APPLY',
      [lblCouponlistShowMoreTxt]: 'Show more',
      [lblCouponlistLessMoreTxt]: 'Show less',
      [lblCouponlistApplyTobag]: 'Apply to bag',
      [lblCouponlistPrintTxt]: 'Print',
      [lblCouponlistUseBy]: 'Use by',
      [lblCouponlistModalLongDesc]:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla urna nunc, interdum ac neque non, blandit accumsan justo. Phasellus aliquam urna ut nisl faucibus, quis pellentesque nulla vulputate. Phasellus bibendum lobortis orci, condimentum convallis sa',
      [lblCouponlistModalShortDesc]: 'By participating in the activity, you agree to ',
      [lblCouponlistPPolicy]: 'Privacy Policy',
      [lblCouponlistPlaceCash]: 'PLACE BUCKS',
      [lblCouponlistRewards]: 'REWARDS',
      [lblCouponlistSavings]: 'SAVINGS',
      [lblCouponlistExpiring]: 'EXPIRING SOON!',
      [lblSflViewsfl]: 'View Saved for Later',
      [lblSflMaxLimitError]:
        'Sorry you have reached the max number of items that can be saved for later.',
      [lblSflActionError]: 'Sorry we were unable to save your item for later at this time.',
      [blSflActionSuccess]: 'Item saved for later successfully.',
      [lblSflMoveToBag]: 'Move To Bag',
      [lblSflSavedForLater]: 'SAVED FOR LATER',
      [lblCouponCollapsibleHeader]: 'Rewards & Offers',
      [lblSflSavedLaterButton]: 'Saved for Later',
      [lblSflEmptySflMsg1]: 'Not ready to buy anything yet?',
      [lblSflEmptySflMsg2]: 'You can save it for later and it will appear in this area.',
      [lblItemDeleteModalTitle]: 'Want to save it instead?',
      [lblItemDeleteModalHeading]:
        'It’ll be in the Saved For Later section when you’re ready to shop.',
      [lblItemDeleteModalButtonSFL]: 'YES, SAVE FOR LATER',
      [lblItemDeleteModalButtonConfirmDelete]: 'NO THANKS',
      [lblMsgItemDeleteSuccess]: 'Your item has been deleted.',
      [lblSflItemDeleteSuccess]: 'Your item has been removed.',
      [lblOrderledgerTitle]: 'Order Summary',
      [lblOrderledgerGiftServices]: 'Gift Service',
      [lblCouponSeeRedeemDates]: 'See Redeem Dates',
      [lblFreeShippingBannerLabel]: '#tagOpen# NEW! #tagClose# FREE Shipping Every Day!',
      [lblFreeShippingBannerUrlApp]: '/content/free-shipping',
      [lblSflItemMoveToBagSuccess]: 'Your item has been added to bag.',
      [lblOrderledgerTotalConfirmation]: 'Total',
      [lblConfirmationPaidWithVenmo]: 'Paid with',
      [lblVenmoProceedCheckout]: 'Proceed to checkout with ',
      [lblEddArrivesby]: 'Arrives by',
      [lblCouponExpiredError]:
        'The coupon applied  to your order coupon_placeholder is no longer valid. Please remove the coupon to continue',
      [lblSflCartSflMergedSuccessMsg]:
        'Item(s) from your last visit moved to Saved For Later section',
      [lblCouponPlaceCashError]: 'Sorry, we are unable to apply your PLACE BUCKS.',
      [lblApplepayNonEligibleStateErrorMessage]: 'Please enter valid 2 character state code',
      [lblApplepayNonEligibleCountryErrorMessage]: 'Shipping available in US only',
      [lblApplepayEstimatedTax]: 'Est. Tax (final tax at checkout)',
      [lblApplepaySubTotal]: 'Subtotal',
      [lblYouRecentlyViewed]: 'RECENTLY VIEWED',
      [lblYouMayAlsoLike]: 'BASED ON ITEMS IN YOUR BAG',
      [lblApplepayRequiredCity]: 'City is required field',
      [lblApplepayRequiredState]: 'State is required field',
      [lblApplepayRequiredPostalCode]: 'Postal code is required field',
      [lblApplepayMultipleLocations]: 'PICKUP AT MULTIPLE LOCATIONS',
      [lblApplepayPickUpAt]: 'PICKUP AT',
      [lblApplepayGiftServices]: 'Gift Services',
      [lblApplepayNoLastNameErrorMessage]: 'First and Last name fields are required',
      [lblApplepayInvalidStreetName]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidCityOrState]:
        'The city and/or state entered is invalid, please correct the address',
      [lblApplepayInvalidHouseNumber]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidPoBoxNumber]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidMailboxNumber]:
        'The address entered is invalid, please correct the address',
      [lblApplepayInvalidAddress]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidPostalCode]: 'The address entered is invalid, please correct the address',
      [lblApplepayNoPhoneNumberErrorMessage]: 'A valid phone number is required.',
      [lblApplepayNoEmailAddressErrorMessage]: 'A valid email address is required.',
      [lblApplepayDiscounts]: 'Discounts',
      [lblCouponMergecartError]:
        'A coupon previously applied to your cart is no longer applicable. Please review your cart for any changes',
      [lblCouponMaxQuantityError]:
        'You have reached the limit for the number of items in your bag. Please review your cart as some of your items may not have merged.',
      [lblSigninCtaBannerSignin]: 'Sign in',
      [lblYouMayAlsoLikeEmptyBagPage]: 'You May Also Like',
      [lblRecentlyViewedEmptyBagPage]: 'Recently Viewed',
      [lblYouMayAlsoLikeFullBagPage]: 'You May Also Like',
      [lblRecentlyViewedFullBagPage]: 'Recently Viewed',
      [lblConfirmationPage]: 'YOU MAY ALSO LIKE',
      [lblConfirmationPageOrderNotification]: 'YOU MAY ALSO LIKE',
      [lblCouponOnholdError]:
        'This coupon will apply to your purchase when you use your My Place Rewards Credit Card.',
      [lblCouponlistOnhold]: 'On Hold',
      [lblEstimateToArrive]: 'Estimated to arrive by',
      [lblPreorderItemsEdd]: '*Pre-order items expected to ship by',
      [lblFreeShippingCartTile]: 'Free Shipping',
      [lblNeedASAPCartTile]: 'Need it ASAP? Get it today!',
      [lblPtsCartTile]: 'Pts',
      [lblQtyCartTile]: 'qty',
      [lblCheckCoupons]: 'Check Coupons',
      [lblLowInvetoryCartTile]: 'Only [val] left in stock - order soon.',
      [lblLowInvetoryThresholdShipToHome]: '13',
      [lblLowInvetoryThresholdBOSS]: '12',
      [lblLowInvetoryThresholdBOPIS]: '10',
      [lblFreeShipping]: 'Free Standard Shipping',
      [lblLowInvetoryThresholdSFL]: '11',
      [lblRewardAndCouponTitle]: 'Rewards & Coupons',
      [lblEstimatedOrderTotal]: 'Estimated Order Total',
      [lblUseByDate]: 'Use By',
      [lblCouponAppleOnholdError]: 'Please pay with Apple Pay to apply this coupon.',
      [lblPreorderDate]: 'PREORDER - SHIPS BY',
      [lblCouponRemovedError]:
        'One or more of your coupons cannot be applied to your order; see coupon details. Please review and resubmit your order.',
      [lblEstimatedTaxAdd]: 'Add Zip Code',
      [lblBagItemDeleteSuccess]: 'An item has been deleted from your bag.',
      [lblQtyText]: 'Qty',
      [lblPreOrderTag]: 'Pre Order',
      [lblEstimatedToShip]: 'Estimated to ship by',
      [lblVmpError]:
        "Sorry one or more items in your cart are exclusive to Children's Place or Gymboree. If you still need those items please ## to checkout from that site.",
      [lblEstimatedZipPlaceholderCa]: 'Postal Code',
      [lblEstimatedTaxAddCa]: 'Add Postal Code',
      [lblPlccIcMyPlaceRewards$]: 'My Place Rewards$',
      [lblPlccIcCreditCard]: 'CREDIT CARD',
      [lblPlccIcInstantCheckout]: 'INSTANT CHECKOUT',
      [lblPlccIcBuyNow]: 'BUY NOW',
      [lblPlccIcShippingAdress]: 'Shipping to #adress',
      [lblPlccIcStoreAddressBossBopis]: '#username will Pick Up at #storeAdress',
      [lblPlccIcTermsCondition]:
        '<style>     .linking-create {         color: #000;         text-decoration: none;         text-decoration: underline;     } </style> By selecting “Buy Now”, I agree to the  <a class="linking-create"     href="/help-center/terms-conditions#termsandconditions" target="_blank">Terms & Conditions</a> and <a     class="linking-create" href="/help-center/policies#privacypolicy" target="_blank">Privacy Policy</a>',
      [lblPlccIcToolTipMessage1]:
        'NEW! Buy Now is the fastest way to check out every time you shop with your online account. ',
      [lblPlccIcTermsConditionPreTextApp]: 'By selecting “Buy Now”, I agree to the ',
      [lblPlccIcToolTipMessage2]:
        'When you select Buy Now, we’ll charge the My Place Rewards Credit Card saved in your account and deliver to your default shipping address. Your order will be placed with a single click, and you’ll be directed to the Order Confirmation page.  ',
      [lblExtendedPreOrderMsg]: 'Limited payment methods',
      [lblExtendedPreOrderToolTipMsg]:
        'Due to the extended timeframe of this pre-order item, we are unable to accept PayPal, Afterpay, Apple Pay and Venmo payments.',
      [lblExtendedPreOrderFooterMsg]:
        'Limited payment methods available in checkout due to select pre-order items.',
      [lblOrderledgerBuyWith]: 'Buy With',
      [lblHolidayMessage]: 'Choose #shippingMethod to get in time for Christmas!',
      [lblHolidayMessageConfirmation]: 'You will get this item before Christmas!',
      [lblCouponInvalidFormatError]: 'Please enter a valid promo code',
      [test]: '1',
      [lblCouponUnapplied]: 'Unapplied Coupons',
      [lblCouponAfterpayMsg]:
        'You have unapplied coupons! To use them on this order, apply them now before continuing to Afterpay.',
      [lblCouponAfterpayPickupFrom]: 'Pickup Items from',
      [lblLoginSuggestionForSfl]: "Log in to see the items you've saved for later!",
      [lblSavingForLaterSuggestion]:
        "Select 'Save for Later' and we'll hold onto your items until you're ready to make a purchase.",
      [lblCouponformNewHeaderText]: 'Benefits, Rewards & Offers',
      [lblSocialProofingMsg]:
        'PLACE Bucks ends TODAY - <span class="social-proof-checkout-msg">spend them now!</span>',
      [lblCouponGenericOnholdMsg]: 'Discount will be applied after Terms and Conditions are met.',
      [lblCouponThresholdOnholdMsg]:
        'Your item total is $XX away from being able to redeem this reward',
      [lblCouponOfferText]: 'OFFER',
      [lblCouponRewardText]: 'REWARD',
      [lblCouponValidThru]: 'Valid thru',
      [lblCouponPlaceCashRedemption]: 'Redemption date is yet to begin',
      [lblBossUnavailableItemLevelError]: 'Unavailable for No-Rush Pickup.',
      [lblBossUnavailableItemLevelError2]: 'Select Ship to Home and get it delivered to your door!',
      [lblBossUnavailableGlobalErrorSubtext]: 'ship them home',
      [lblBossUnavailableConfirmationHeading]: 'We’ve saved the rest of the items in your bag...',
      [lblBossUnavailableConfirmationSubText]: 'Ship them to your home for FREE!',
      [lblHangOn]: 'Hang on...',
      [lblAddingTheItems]: 'We’re adding the item(s) to your bag now!',
      [lblAddItemsToBag]: 'Someone shared their bag with you!',
      [lblUpdateItems]:
        'Select Yes to view items. You can also update the size, color, quantity and more.',
      [lblAddToBag]: 'YES, VIEW ITEMS',
      [lblShareCartCancel]: 'Cancel',
      [lblBossUnavailableConfirmationHeadingOnlyOssItems]: 'Update on cart remaining items!',
      [lblBagpageShareCart]: 'Share Bag',
      [lblShareCartSmsCopy]: 'Check out the styles I found at #brandId today: ',
      [lblHolidayDate]: 'Oct 30 2023',
    },
    billing: {
      referred: [
        {
          name: 'cvv_info',
          contentId: '4dc98969-cd2b-4a0e-b2d6-3949a5066458',
          __typename: 'ReferredContent',
        },
        {
          name: '',
          contentId: '224f768d-454d-4b73-baf0-85e82d2099f6',
          __typename: 'ReferredContent',
        },
        {
          name: '',
          contentId: '726bd000-3287-4fc4-b4c2-733d41f7689e',
          __typename: 'ReferredContent',
        },
        {
          name: '',
          contentId: 'e0153316-71b6-47d4-a881-b112ab485f21',
          __typename: 'ReferredContent',
        },
      ],
      [lblBillingTitle]: 'BILLING',
      [lblGiftcardAddUptoMsg]: 'Add up to #maxGiftCard# gift cards and/or merchandise credits.',
      [lblGiftcardAppliedCards]: 'Applied Gift Cards',
      [lblGiftcardEndingIn]: 'Ending in',
      [lblGiftcardRemainingBal]: 'Remaining Balance',
      [lblGiftcardHeadsUpTitle]: 'Heads Up!',
      [lblGiftcardHeadsUpMsg]:
        'Please keep your Gift Card until you receive the item(s) purchased.',
      [lblGiftcardAvailableCards]: 'Available Gift Cards',
      [lblGiftcardApplyBtn]: 'Apply',
      [lblGiftcardNewGiftCard]: 'ADD A NEW GIFT CARD',
      [lblGiftcardCommonError]: 'Oops... an error occurred.',
      [lblBillingBackLinkPickup]: 'Return to Pickup',
      [lblBillingBackLinkShipping]: 'Return to Shipping',
      [lblBillingNextSubmit]: 'NEXT: REVIEW',
      [lblBillingPaymentMethodTitle]: 'Payment Method',
      [lblBillingSelectFromCard]: 'Select from card on file',
      [lblBillingAddCreditHeading]: '+ Add a new Credit Card',
      [lblBillingDefault]: 'Default',
      [lblBillingCardDetailsTitle]: 'Card Details',
      [lblBillingCreditCardEnd]: 'ending in ',
      [lblBillingBillingAddress]: 'Billing Address',
      [lblBillingDefaultPayment]: 'Set as default payment method',
      [lblBillingAddCreditBtn]: 'ADD A NEW CREDIT CARD',
      [lblBillingPaypal]: 'Pay Pal',
      [lblBillingVenmo]: 'Venmo',
      [lblBillingDefaultCard]: 'DEFAULT',
      [lblBillingSelectCardTitle]: 'SELECT CARD',
      [lblBillingSelect]: 'SELECT',
      [lblPaymentGiftCardNoPlaceholder]: 'Gift Card #',
      [lblPaymentAddCard]: 'Apply',
      [lblPaymentGiftCardPinPlaceholder]: 'Pin #',
      [lblPaymentSaveToAccount]: 'Save gift card balance to my account',
      [defaultError]: 'Oops... an error occured',
      [lblBillingSameAsShipping]: 'Same as shipping address',
      [lblBillingSaveToAccount]: 'Save card to my account',
      [lblBillingDefaultPayment]: 'Set as default payment method',
      [lblBillingCvvCode]: 'CVV',
      [lblBillingAddNewAddress]: '+ Add a new address',
      [lblBillingContinueWith]: 'Continue with',
      [lblBillingCardEditSave]: 'Save',
      [lblBillingCardEditUnSavedError]: 'You have one or more unsaved changes.',
      [lblBillingDefaultError]:
        'The payment method entered could not be authorized for this purchase. Please review the information entered and try again or try an alternate form of payment',
      [lblBillingAddCC]: 'Add a new CC',
      [paymentSaveToAccount]: 'Save gift card balance to my account',
      [lblBillingContinueWithPayPal]: 'Complete Purchase with',
      [lblBillingPayPalLongText]:
        "By selecting PayPal, you will leave childrensplace.com to complete the order process with PayPal's site. Upon PayPal payment completion, you will be returned to childrensplace.com Please review your purchase and delivery details before proceeding.",
      [lblBillingVenmoLongText]: 'Tap the Venmo button below to continue with purchase',
      [lblBillingDiffrentcountry_1]:
        'Because your Billing Country is different than your Ship To Country, you will be subject to the exchange rate charged by your bank or credit card company for foreign currency conversions at the time the order is placed.',
      [lblBillingDiffrentcountry_2]:
        'Any returns will be refunded in the currency originally charged at the time of purchase.',
      [lblBillingDiffrentcountry_3]:
        'The Children\u0027s Place is not responsible for any additional bank or credit card fees or for costs related to the currency conversion fees applied by your bank or credit card company.',
      [lblBillingApplepay]: 'Apple Pay',
      [lblApplepaySubTotal]: 'Subtotal',
      [lblApplepayDiscounts]: 'Discounts',
      [lblApplepayEstimatedTax]: 'Est. Tax (final tax at checkout)',
      [lblApplepayNonEligibleStateErrorMessage]: 'Please enter valid 2 character state',
      [lblApplepayNonEligibleCountryErrorMessage]: 'Shipping available in US only',
      [lblBillingAfterpaySubmit]: 'CONTINUE WITH AFTERPAY',
      [lblBillingOtherPaymentOptions]: 'Other payment options',
      [lblApplyNow]: 'Apply Now',
      [lblSaveAtCheckoutToday]: 'Save at checkout today!',
      [lblMy]: 'MY',
      [lblPlace]: 'PLACE',
      [lblRewards]: 'REWARDS',
      [lblExpire]: 'Exp',
      [lblMyWallet]: 'My Wallet',
      [lblAddCard]: 'Add Card',
      [lblUpdateCardInfo]: 'Update Card Information',
      [lblAfterPayDefaultMsg]:
        'You will be directed to Afterpay once you submit your order on the next step.',
      [lblExpired]: 'Expired',
      [lblAddNewCard]: 'Add New Card',
      [lblAddNewCardInfo]: 'Add New Card Information',
      [lblEditCardInfo]: 'Edit Card Information',
      [lblEndingWith]: 'Ending with',
      [lblApplyAGiftCard]: 'Apply a Gift Card',
      [lblGiftCardApplied]: 'Gift Cards Applied',
      [lblGiftCardAvailable]: 'Gift Cards Available',
      [lblBalance]: 'Balance',
      [lblBillingSameAsShippingMessage]: 'My billing address is the same as shipping.',
      [lblAfterPayGcInCartMsg]:
        'Afterpay is unavailable for gift card purchases. Please select a new payment method.',
      [lblBillingAfterpay]: 'afterpay',
      [lblOrderTotalMinThresholdMsg]:
        'Afterpay is available for orders that total under $[AfterPayMinOrderAmount]. Please select a new payment method.',
      [lblBillingPaymentTitle]: 'Payment',
      [lblCvvReverifyMsg]: 'For security reasons, please enter your card’s verification code.',
      [lblAddCardInfo]: 'Add Card Information',
      [lblAddCreditCard]: 'Add Credit Card',
      [lblGiftCardAppliedHeading]: 'Gift Card Applied:',
      [lblAdd]: 'Add',
      [lblAddShippingAddress]: 'Add Shipping Address',
      [lblShippingAddress]: 'Shipping Address',
      [lblBillingSaveToAccountSpc]: 'Save credit card to my wallet',
      [lblOrSeparator]: 'OR',
      [lblEditCreditCard]: 'Edit Credit Card',
      [noLabel]: 'Add Gift Service',
      [lblEditShippingAddress]: 'Edit Shipping Address',
      [lblPaymentSaveToAccountSpc]: 'Save gift card to my account',
      [lblApplyGiftCardCta]: 'Apply Gift Card',
      [lblGiftCardsAppliedHeading]: 'Applied (<card_count>)',
      [lblGiftCardsAvailableHeading]: 'Available (<card_count>)',
      [lblPaymentGiftCardAvailableHeading]: '(Available: <card_count>)',
      [lblApplePayDisplayMessageHeading]: 'Recommended',
      [lblApplePayDisplayMessage]: 'Because Apple Pay is enabled on your device.',
      [lblPaymentReturnForReview]:
        'You will return back to this Checkout page to review and submit your order.',
      [lblApplePayDirectOrder]: 'Your order will be placed directly from Apple Pay.',
    },
    checkoutHeader: {
      referred: [],
      [lblCheckoutheaderCheckout]: 'Checkout',
      [lblCheckoutheaderReturnBag]: 'Return to bag',
      [lblCheckoutHeaderBilling]: 'Billing',
      [lblCheckoutHeaderReview]: 'Review',
      [lblCheckoutHeaderExpressCheckout]: 'EXPRESS CHECKOUT',
      [lblContactHeader]: 'Order Contact',
    },
    orderConfirmation: {
      referred: [
        {
          name: 'Update_Order_Details_BOSS',
          contentId: 'b346500a-279b-489c-8031-c0d6eb026b1c',
          __typename: 'ReferredContent',
        },
        {
          name: 'Update_Order_Details_BOPIS',
          contentId: 'c0a53936-4e9f-4d14-ac1d-185ee8f9c464',
          __typename: 'ReferredContent',
        },
        {
          name: 'Notification_Carrier_Message_US',
          contentId: 'd816dd14-f903-4518-9dc8-59b6bca145ba',
          __typename: 'ReferredContent',
        },
        {
          name: 'Notification_Carrier_Message_CA',
          contentId: 'cbaced5f-f4da-4fec-9676-7bd2a68f6e74',
          __typename: 'ReferredContent',
        },
        {
          name: 'Notification_Success_Msg',
          contentId: '1fd76503-1f04-4147-8d6a-aa603233d4d2',
          __typename: 'ReferredContent',
        },
        {
          name: 'Venmo_Order_Confirmation',
          contentId: 'fd84f17c-85ac-4d74-b896-dbbd03ef9b8e',
          __typename: 'ReferredContent',
        },
      ],
      [lblConfirmationHeading]: 'Thank you #customerName for your order!',
      [lblConfirmationMixOrderMsg1]:
        'You’ll receive emails confirming your pickup status and order info at ',
      [lblConfirmationMixOrderMsg2]:
        '.If a different email address was provided for pickup, status updates will be sent to that email instead.',
      [lblConfirmationOrderMsg1]: 'You’ll receive an email confirmation shortly with',
      [lblConfirmationShippingMsg]: 'your order',
      [lblConfirmationPickup]: 'pickup',
      [lblConfirmationOrderMsg2]: 'info at',
      [lblConfirmationPendingOrderMsg]: 'Order #orderNumber is currently pending payment approval.',
      [lblConfirmationPickupAt]: 'Pickup at',
      [lblConfirmationShippingTo]: 'Shipping to',
      [lblConfirmationItem]: 'ITEM',
      [lblConfirmationBopisDate]: 'Today, ',
      [lblConfirmationToday]: 'Today:',
      [lblConfirmationTomorrow]: 'Tomorrow:',
      [lblConfirmationPhone]: 'Phone:',
      [lblConfirmationOrderNumber]: 'Order #',
      [lblConfirmationOrderDate]: 'Order Date',
      [lblConfirmationOrderTotal]: 'Order Total',
      [lblCreateAccountHeading]: 'Create an account for easier, faster checkout.',
      [lblConfirmationNextHeading]: 'What’s next?',
      [lblConfirmationNextDetailsBoss]:
        'Check your email for your order confirmation. We’ll also let you know when this order is ready for pickup. You will receive separate credit card charges for the items being shipped and items being picked up in store.',
      [lblConfirmationUpdateOrderHeading]: 'Can I update my order?',
      [lblConfirmationNextDetails]:
        "Check your email for your order confirmation. We'll also let you know when your order is ready for pickup. You will receive separate credit card charges for online and pickup orders.",
      [lblOdmCouponsHeading_1]: 'Special Coupons just for you!',
      [lblOdmCouponsHeading_2]: '(Coupon(s) will also be included in your oder emails.)',
      [lblOdmCouponsWebCode]: 'WEB CODE:',
      [lblOdmCouponsValidTill]: 'Valid ',
      [lblOdmCouponsNowThrough]: 'Now through',
      [lblConfirmationVenmoHeading]: 'Venmo Payment',
      [lblConfirmationVenmoShipInformation]:
        'If your order ships after 10 days, a second authorization will appear on your card, however you will only be charged once.',
      [lblConfirmationPaidWithVenmo]: 'Paid with',
      [lblSmsNotificationHeading_1]: 'Join Our Text Alerts',
      [lblSmsNotificationHeading_2]: 'Stay updated on special promos & new arrivals.',
      [lblSmsNotificationJoinNowBtn]: 'JOIN NOW',
      [lblSmsNotificationPhoneLbl]: 'Enter Phone Number',
      [lblSmsNotificationSubscribeSuccess]: 'Thank you for joining our list!',
      [lblConfirmationRatingTitle]: 'Thanks for your order!',
      [lblConfirmationRatingBody]: "Would you like to rate our app? We'd appreciate your feedback.",
      [lblConfirmationRatingSureCTA]: 'Sure',
      [lblConfirmationRatingMayBeCTA]: 'May be later',
      [lblHelpWithOrderReceipts]: 'Receipts',
      [lblHelpWithOrderModalOpen]: 'Order Help',
      [lblMoreHelpResendConfirmText]: 'Resend Order Confirmation',
      [lblMoreHelpReturnPolicyText]: 'Return Policy',
      [lblMoreHelpChangePickUpText]: 'Change Pick Up Person',
      [lblMoreHelpExtendPickUpText]: 'Extend Pick Time',
      [lblOrderStatusHelpText]: 'Contact Us About Your Order',
      [lblHelpCenterText]: 'Help Center',
      [lblOrderStatusText]: 'Order Status',
      [lblLeaveFeedbackText]: 'Leave Feedback',
      [lblNeedHelpText]: 'Need help?',
      [lblConfirmationGuestInstructionMsg]: 'Log in every time you shop to earn points.',
      [lblConfirmationGuestConversionMsg]: 'Your account has been created.',
      [lblConfirmationGuestConversionYey]: 'Yay!',
      [lblConfirmationOrderDetailsHeading]: 'Order Details',
      [lblConfirmationOrderDetailsItemCount]: 'Item Count',
      [lblConfirmationOrderDetailsHelpCenterText]:
        '<style>p{font-size:14px; font-family: Nunito;}a{color:black;}</style><p>If you have questions about your order, <a href="/us/help-center/faq" title="Help Center" target="_blank">visit the help center</a> to learn more.',
      [lblConfirmationOrderNumberMsg]: 'Your order number is #orderNumber.',
      [lblConfirmationOrderNumberMsgNew]: 'Your order numbers are #orderNumber.',
      [lblMoreHelpResendConfirmImg]:
        'https://assets.theplace.com/image/upload/v1595348482/ecom/assets/static/detail-menu/resend.svg',
      [lblMoreHelpReturnPolicyUrl]: '/help-center/returns-exchanges#returnsandexchanges',
      [lblMoreHelpReturnPolicyImg]:
        'https://assets.theplace.com/image/upload/v1595348498/ecom/assets/static/detail-menu/ic_keyboard_return_24px.svg',
      [lblOrderStatusHelpImg]:
        'https://assets.theplace.com/image/upload/v1604421872/ecom/assets/static/order-help/package.svg',
      [lblOrderStatusHelpUrl]: '/content/order-status-help?icid=account_na_na_110620_na_onlinehelp',
      [lblHelpCenterUrl]: '/help-center/faq',
      [lblOrderStatusUrl]: '/help-center/order-help#orderstatus',
      [lblNeedHelpImg]:
        'https://assets.theplace.com/image/upload/v1595348478/ecom/assets/static/detail-menu/icon-feedback_3x.png',
      [lblLeaveFeedbackUrl]:
        'http://ips-invite.iperceptions.com/webValidator.aspx?sdfc=355b766d-128721-c733c77b-141a-42d7-be9f-2e52b426622b&lID=1&source=102226',
      [lblCreateAccountHeading1]: 'Create an account today to earn points on your next purchase!',
      [lblCreateAccountSubHeading1]: 'Create a password to create your account.',
      [lblCreateAccountSucccessMsg]: 'Your account has been created!',
      [lblCreateAccountSucccessMsgPara]: 'Log in every time you shop to earn points.',
      [lblCreateAccountSucccessYay]: 'Yay! ',
      [lblReferAFriendHeadingForFriend]: '$10 for a friend',
      [lblReferAFriendHeadingForYou]: '$10 for you!',
      [lblReferAFriendBtnText]: 'REFER A FRIEND',
      [lblInitiateReturnImg]:
        'https://assets.theplace.com/image/upload/v1633439924/ecom/assets/static/images/item-returned.svg',
      [lblConfirmationEmailSignUpHeader]: 'Sign up for Emails',
      [lblConfirmationCarrierMessage]:
        "*By signing up, you agree to provide certain personal information for use by The Children’s Place or Gymboree. You can withdraw your consent at any time. See <a href='/help-center/policies#privacypolicy'>Privacy Policy</a>. <a href='/help-center/contact-us'>Contact Us</a>: Gymboree, 500 Plaza Drive, Secaucus, NJ 07094, <a href='www.gymboree.com'>www.gymboree.com</a>.",
    },
    pickup: {
      referred: [],
      [lblPickupTitle]: 'PICKUP',
      [lblPickupTitleContact]: 'Pickup Contact',
      [lblPickupGovIdText]: 'A government issued ID is required to pickup the order.',
      [lblPickupMobile]: 'Mobile Number',
      [lblPickupAlternativeHeading]: 'Add an alternate pickup person (optional)',
      [lblPickupAlternativeSubHeading]:
        'Alternate pickup contact will also receive a copy of all Order Pickup emails.',
      [lblPickupAlternativeGovIdText]: 'A government issued ID is required to pickup the order.',
      [lblPickupEmailSignupContact]: 'Contact us.',
      [lblPickupPickupContact]: 'Pickup Contact',
      [lblPickupReturnTo]: 'Return to',
      [lblPickupNextText]: 'NEXT',
      [lblPickupBillingText]: 'BILLING',
      [lblPickupBtnSaveUpdate]: 'Save Pickup Details',
      [lblPickupTitleEditPickUp]: 'EDIT PICKUP',
      [lblPickupVenmoBanner]:
        'To complete your Venmo payment, we’ll need a little more information.',
      [lblPickupReviewText]: 'REVIEW',
      [lblPickupNextToBilling]: 'NEXT: SHIPPING',
      [lblPickupEditFormSubmitError]: 'You have unsaved changes.',
      [lblPickupInfoTitle]: 'Pickup Information',
      [lblPickupContactTitle]: 'Pickup Contact',
      [lblAlternatePickupContactTitle]: 'Alternate Pickup Contact',
      [lblEditPickupInfoTitle]: 'Edit Pickup Info',
      [lblPickupDescOne]:
        'We’ll send an email when your pickup order is ready. A government-issued ID is required for pickup.',
      [lblAlternatePersonSwitch]: 'Add an alternate pickup person (optional)',
      [lblPickupDescTwo]: 'Alternate pickup person will receive a copy of all Order Pickup emails.',
      [lblCheckouterrorMsg]: 'Please save your information before submitting the order',
      [lblCheckouterrorContactMsg]: 'Please enter contact information',
      [lblCheckouterrorShipmentMsg]: 'Please enter shipping information',
      [lblCheckouterrorPaymentMsg]: 'Please enter payment information',
    },
    placeCashBanner: {
      referred: [
        {
          name: 'PlaceCash_Detail_US_confirmation',
          contentId: '93dfb1fa-f6fa-49e1-b34a-eea965d384c6',
          __typename: 'ReferredContent',
        },
        {
          name: 'PlaceCash_Detail_CA_bag',
          contentId: 'f85619e6-38cd-4a99-8d5a-f35d3bd9962c',
          __typename: 'ReferredContent',
        },
        {
          name: 'PlaceCash_Detail_CA_confirmation',
          contentId: 'b910b037-95c9-4439-a1e5-1b88a0f7970e',
          __typename: 'ReferredContent',
        },
        {
          name: 'PlaceCash_Detail_US_bag',
          contentId: 'c7bd7991-bbd2-4a1e-907b-8fa2c0ad3f96',
          __typename: 'ReferredContent',
        },
      ],
      [lblPlaceCash_USBagTitle]: 'YAY! You’ll Earn #earnedPlaceCashValue# in PLACE Bucks',
      [lblPlaceCash_CABagTitle]: 'YAY! You’ll Earn #earnedPlaceCashValue# in PLACE Bucks',
      [lblPlaceCash_USConfirmationTitle]:
        'YAY! You have earned #earnedPlaceCashValue# in PLACE Bucks ',
      [lblPlaceCash_CAConfirmationTitle]:
        'YAY! You have earned #earnedPlaceCashValue# in PLACE Bucks',
      [lblPlaceCash_USBagSubTitle]: 'Get #cashAmountOff#  for every #placeCashOffer# you spend!',
      [lblPlaceCash_CABagSubTitle]: 'Get #cashAmountOff#  for every #placeCashOffer# you spend!',
      [lblPlaceCash_USBagTnc]: 'Cannot be combined with any other offer. Terms & conditions apply.',
      [lblPlaceCash_CABagTnc]: 'Cannot be combined with any other offer. Terms & conditions apply.',
      [lblPlaceCash_USConfirmationTnc]:
        'Confirmation: Cannot be combined with any other offer. Terms & conditions apply.',
      [lblPlaceCash_CAConfirmationTnc]:
        'Confirmation: Cannot be combined with any other offer. Terms & conditions apply.',
      [lblPlaceCash_USBagModalLink]: 'See Details',
      [lblPlaceCash_CABagModalLink]: 'See Details',
      [lblPlaceCash_USConfirmationModalLink]: 'See Details Confirm',
      [lblPlaceCash_CAConfirmationModalLink]: 'See Details Confirm',
      [lblPlaceCash_USBagDetailModalTitle]: 'Place Bucks Detail',
      [lblPlaceCash_CABagDetailModalTitle]: 'Place Bucks Detail',
      [lblPlaceCash_USConfirmationDetailModalTitle]: 'Place Bucks Detail Confirmation',
      [lblPlaceCash_CAConfirmationDetailModalTitle]: 'Place Bucks Detail Confirmation',
      [lblPlaceCashProgress_USBeforeCartAmount]: 'You are only ',
      [lblPlaceCashProgress_USAfterAmount]: 'away from your next PLACE Bucks coupon',
      [lblPlaceCashProgress_USPlaceBucks]: ' PLACE Bucks',
      [lblPlaceCashProgress_CAPlaceBucks]: ' PLACE Bucks',
      [lblPlaceCashProgress_CAAfterAmount]: 'away from your next PLACE Bucks coupon',
      [lblPlaceCashProgress_CABeforeCartAmount]: 'You are only ',
      [lblPlaceCashProgress_USBetweenAmount]: ' away from your next ',
      [lblPlaceCashProgress_CABetweenAmount]: ' away from your next ',
      [lblPlaceCashProgress_USAfterBucks]: ' coupon ',
      [lblPlaceCashProgress_CAAfterBucks]: ' coupon ',
      [lblPlaceCash_USBagStartDate]: '03/01/2022',
      [lblPlaceCash_USBagEndDate]: '06/30/2022',
      [lblPlaceCashToUse]: ' to use ',
      [lblPlacerewardModelHeader]: 'Place reward',
      [lblPlacerewardModelDescription]: 'Place reward desc',
      [lblPlacerewardUsProgressBeforePoints]: 'You are only ',
      [lblPlacerewardUsProgressTitle2]: ' point(s) away from earning another ',
      [lblPlacerewardUsProgressAfterPoints]: ' Reward!',
      [lblPlacerewardUsProgressRewardValue]: '$5',
      [lblPlaceCash_USBagAltName]: 'Place Cash Background Image',
      [lblPlaceCash_CABagAltName]: 'Place Cash Background Image',
    },
    review: {
      referred: [
        {
          name: 'submit_order_policy',
          contentId: 'a35d0c09-3bd3-414f-ad3b-0aba4f8a6baa',
          __typename: 'ReferredContent',
        },
      ],
      [lblReviewTitle]: 'REVIEW',
      [lblReviewBackLinkBilling]: 'Return to Billing',
      [lblReviewNextSubmit]: 'Submit Order',
      [lblReviewApplyConditionPreText]: 'By selecting “Submit Order”, I agree to the ',
      [lblReviewApplyConditionAndText]: ' and ',
      [lblReviewApplyConditionPolicyText]: 'Privacy Policy.',
      [lblReviewBillingSectionTitle]: 'Billing',
      [lblReviewPickupSectionTitle]: 'Pickup Contact',
      [lblReviewPaymentMethod]: 'Payment Method',
      [lblReviewAppliedGiftCards]: 'Applied Gift Cards',
      [lblReviewBillingAddress]: 'Billing Address',
      [lblReviewPaymentMethodEndingIn]: 'ending in',
      [lblReviewAppliedGiftCardEndingIn]: 'Ending In',
      [lblReviewAppliedGiftCardRemainingBal]: 'Remaining Balance',
      [lblReviewGiftCardHeadsup]: 'Heads Up!',
      [lblReviewGiftCardMessage]:
        'Please keep you Gift Card until you receive the item(s) purchased.',
      [lblReviewAppliedGiftCardsNone]: 'None',
      [lblReviewSectionPickupText]:
        'We will send you an email when your order is ready. A government issued ID is required to pick up the order.',
      [lblReviewSectionPickupItem]: 'ITEM',
      [lblReviewSectionPickupItems]: 'ITEMS',
      [lblReviewSectionPickupToday]: 'Today,',
      [lblReviewSectionPickupAlternateHeading]: 'Alternate Pickup Contact',
      [lblReviewSectionShippingAddressTitle]: 'Shipping Address',
      [lblReviewSectionShippingMethodTitle]: 'Shipping Method',
      [lblReviewSectionShippingGiftServiceTitle]: 'Gift Services',
      [lblReviewSectionShippingGiftServiceDefault]: 'N/A',
      [lblReviewSectionPickupOrderTitle]: 'PICK UP',
      [lblReviewSaveVenmo]: 'Save to my account',
      [lblReviewShippingShipmentHeader]: 'Shipping Method',
      [lblReviewCvvCode]: 'CVV',
      [lblReviewEmptyBagSubText]:
        "Your shopping bag is empty. Shopping bags are saved for 14 days for account holders. Try logging in to your account to view a saved shopping bag. If you don't see your items you may have not made your selections correctly on the product page.",
      [lblReviewEmptyBagText]: 'YOUR SHOPPING BAG IS EMPTY',
      [lblReviewAfterpaySubmit]: 'Submit Order With Afterpay',
      [lblReviewCashAppAfterpaySubmit]: 'Submit Order With',
      [lblReviewAfterpayMessage]: 'You will be directed to Afterpay once you submit your order.',
      [lblReviewAfterpayThresholdError]:
        'Afterpay is available for orders that total between $[AfterPayMinOrderAmount] - $[AfterPayMaxOrderAmount]. Please select a new payment method.',
      [lblReviewApplyConditionTermsText]: 'Terms & Conditions',
    },
    shipping: {
      referred: [
        {
          name: 'GiftServicesDetailsTCPModal',
          contentId: '74ed2188-f294-4e0b-8643-bff562aadbf2',
          __typename: 'ReferredContent',
        },
        {
          name: 'GiftServicesDetailsGYMModal',
          contentId: '89e51e9e-a0c2-4082-819f-e3d843461f19',
          __typename: 'ReferredContent',
        },
        {
          name: 'GiftServicesDetailsSNJModal',
          contentId: 'eaeaf2d8-37b8-4ea8-966c-267c264abab5',
          __typename: 'ReferredContent',
        },
        {
          name: 'EmailDisclaimer',
          contentId: 'f0c3b8cb-79ab-4e9b-bee6-085998043a82',
          __typename: 'ReferredContent',
        },
        {
          name: 'email_sign_up_ca',
          contentId: 'b7aedc7f-2e00-442c-b4cf-86fa405199a3',
          __typename: 'ReferredContent',
        },
        {
          name: 'GiftServicesDetailsTCPModal',
          contentId: '74ed2188-f294-4e0b-8643-bff562aadbf2',
          __typename: 'ReferredContent',
        },
      ],
      [lblShippingHeader]: 'SHIPPING',
      [lblShippingSectionHeader]: 'Shipping Details',
      [lblShippingShipmentHeader]: 'Shipping Method',
      [lblShippingBackLinkText]: 'Return to Pickup',
      [lblShippingBillingText]: 'NEXT: BILLING',
      [lblShippingAddNewAddress]: ' + Add A New Address',
      [lblShippingEdit]: ' Edit',
      [lblShippingSaveToAccount]: 'Save to my address book',
      [lblShippingDefaultShipping]: 'Set as default shipping address',
      [lblShippingSave]: 'Save',
      [lblShippingSelectShipAdd]: 'SELECT THIS SHIPPING ADDRESS',
      [lblShippingAddHeading]: 'ADD NEW ADDRESS',
      [lblShippingEditHeading]: 'EDIT ADDRESS',
      [lblGiftServicesHeader]: 'Gift Services',
      [lblGiftServicesAdd1]: '',
      [lblGiftServicesAdd]: 'Add a personalized message, gift receipt and/or gift boxes.',
      [lblGiftServicesSelect]: 'Select from the options below.',
      [lblShippingGiftServicesTcpOptionName1]: 'Gift Receipt / Gift Message Only',
      [lblShippingGiftServicesGymOptionName1]: 'Gift Receipt / Gift Message Only',
      [lblShippingGiftServicesTcpOptionPrice1]: 'FREE',
      [lblShippingGiftServicesTcpOptionDesc1]:
        'Encrypted prices and gift message will appear on packing slip. Price tags are not removed.',
      [lblShippingGiftServicesGymOptionDesc1]:
        'Encrypted prices and gift message will appear on packing slip. Price tags are not removed.',
      [lblShippingGiftServicesTcpOptionName2]: 'Standard Gift Service',
      [lblShippingGiftServicesGymOptionName2]: 'Standard Gift Service',
      [lblShippingGiftServicesTcpOptionDesc2]:
        'Gift it! Include a fun gift box, tissue paper, and a message to your order.',
      [lblShippingGiftServicesGymOtionDesc2]:
        'Gift it! Include a fun gift box, tissue paper, and a message to your order.',
      [lblShippingGiftServicesTcpOptionName3]: 'Delux Gift Service',
      [lblShippingGiftServicesGymOptionName3]: 'Delux Gift Service',
      [lblShippingGiftServicesTcpOptionDesc3]:
        'We’ll package everything in a fun gift box with tissue paper and a message then ship it directly to the recipient.',
      [lblShippingGiftServicesGymOptionDesc3]:
        'We’ll package everything in a fun gift box with tissue paper and a message then ship it directly to the recipient.',
      [lblShippingDefault]: 'DEFAULT',
      [lblGiftServicesCharLimit]: '100 character limit',
      [lblGiftServicesAddMessage]: 'Add your message',
      [lblShippingReviewText]: 'NEXT: REVIEW',
      [lblShippingAddressEditError]: 'Please save your changes or cancel to proceed with checkout',
      [lblShippingEmailSignUpHeader]: 'SIGN UP FOR EMAILS*',
      [lblShippingEmailSignUpSubHeader]: 'Stay updated on special promos & new arrivals.',
      [lblShippingGymboreePlaceCheckoutTxt]: 'Gymboree',
      [lblShippingEmailSignUpDisclaimer]: `*You may withdraw your consent at any time. Contact Us: The Children’s Place and Gymboree, 500 Plaza Drive, Secaucus, NJ 07094, <a href="/" style="color:black;">www.childrensplace.com</a> and <a href="/" style="color:black;">www.gymboree.com</a>.`,
      [lblGiftServicesHelp]: 'Gift Services Help',
      [lblSfsShippingAddressError]: 'Important message for your shipping address.',
      [lblSfsCartItemError]: 'Important message for your cart',
      [lblSfsOrderError]: 'Important message for your order.',
      [lblSfsErrorRushShipping]:
        'X item(s) in your cart are not eligible for Express or RUSH shipping.',
      [lblSfsErrorGiftService]: 'X item(s) in your cart not eligible for gift services.',
      [lblSfsErrorShippingAddress]:
        'X item(s) in your cart not eligible.  APO/FPO address entered is not eligible.',
      [lblSfsErrorAddressRush]:
        'X Item(s) in your cart are not eligible for shipment to APO/FPO address and Expedited/RUSH Shipping.',
      [lblSfsErrorGiftAddress]:
        'X item(s) in your cart not eligible for gift services and the APO/FPO address entered is not eligible.',
      [lblSfsErrorGiftRush]:
        'X Item(s) in your cart are not eligible for Rush/Expedited Shipping and Gift Services',
      [lblSfsSflCta]: 'Save Items For Later & Continue',
      [lblSfsAddressCta]: 'Change Address',
      [lblSfsShippingCta]: 'Select Standard Shipping',
      [lblSfsGiftserviceCta]: 'Update Gift Services',
      [lblAddGiftServices]: 'Add Gift Services',
      [lblCheckboxYes]: 'YES',
      [lblCheckboxNo]: 'NO',
      [lblGiftServiceOptionNone]: 'None',
      [lblGiftServiceSave]: 'Save',
      [lblGiftServiceOptional]: 'Optional',
      [lblGiftServiceSelectABrand]:
        'Select a brand and a gift service. Add a personalized message, gift receipt, and/or gift box.',
      [lblNoGiftServiceSelected]: 'No Gift Services Selected',
      [lblShippingAddressHeader]: 'Shipping Address',
      [lblShippingEmailSignUpHeaderCaNew]: 'Sign Up For Emails',
      [lblGiftServiceNoteStandard]:
        '<b>*Note:<b/> Gift Boxes will not be sent for each item in your order. you’ll receive an estimated number of boxes needed to gift all the items from your purchase to one recipient.',
      [lblGiftServiceNoteDelux]:
        '<b>*Note:</b> If choosing this service, please note that all merchandise in your cart will be shipped directly to gift recipient. We are unable to split shipments at this time.',
    },
  },
};
